import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCakeCandles,
  faGift,
  faLock,
  faLocationDot,
  faUserGroup,
  faUserShield
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import backgroundImage from '../Images/fundoaniversario.png';
import '../CSS/Despedidas.css';

const Aniversarios = () => {
  return (
    <div className="er-partyPage">
      <section className="er-partyHero" aria-label="Aniversários">
        <img src={backgroundImage} alt="" className="er-partyHeroImg" />
        <div className="er-partyHeroOverlay">
          <div className="er-partyHeroInner">
            <div className="er-partyBadge">Aventura • Risos • Surpresas</div>

            <h1 className="er-partyTitle">
              Aniversários <span className="er-partyTitleAccent">Inesquecíveis</span>
            </h1>

            <p className="er-partyLead">Celebra de forma diferente!</p>
            <p className="er-partyText">
              Junta amigos e família para um desafio cheio de adrenalina, mistério e momentos para contar.
              Ideal para marcar o dia de forma única — com planos adaptados ao vosso grupo.
            </p>

            <div className="er-partyCtas">
              <a
                className="er-partyCtaPrimary"
                href="https://wa.me/351934403133"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                Falar connosco
              </a>
            </div>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faCakeCandles} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Festa com adrenalina</h2>
              <p className="er-partyHeroCardText">
                Uma celebração diferente: energia alta e diversão desde o primeiro minuto.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLock} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Desafios épicos</h2>
              <p className="er-partyHeroCardText">
                Enigmas para testar a cooperação e a criatividade do grupo.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faGift} className="er-partyHeroCardIcon" />
              <h2 className="er-partyHeroCardTitle">Memórias únicas</h2>
              <p className="er-partyHeroCardText">
                Momentos para recordar e histórias para contar muito mais tarde.
              </p>
            </article>
          </div>

          <div className="er-partyHeroCards">
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserGroup} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">Para todos os grupos</h3>
              <p className="er-partyFeatureText">
                Adaptamo-nos ao tamanho e ao ritmo do vosso grupo.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faLocationDot} className="er-partyFeatureIcon" />
              <h2 className="er-partyHeroCardTitle">Localização top</h2>
              <p className="er-partyFeatureText">
                No coração de Bragança, fácil de chegar e perfeito para continuar a festa.
              </p>
            </article>
            <article className="er-partyHeroCard">
              <FontAwesomeIcon icon={faUserShield} className="er-partyFeatureIcon" />
              <h3 className="er-partyHeroCardTitle">Equipa dedicada</h3>
              <p className="er-partyFeatureText">
                Apoio antes, durante e depois do jogo para tudo correr sem stress.
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Aniversarios;
